import React, { useState } from "react";
import classes from "./textToArrayConverter.module.css";

const TextToArrayConverter = () => {
  const [inputText, setInputText] = useState("");
  const [outputArray, setOutputArray] = useState([]);
  const [arrayFormat, setArrayFormat] = useState("javascript");

  const handleInputChange = (event) => {
    const text = event.target.value;
    setInputText(text);

    // Convert text to array (split by newlines and filter out empty lines)
    const lines = text.split("\n").filter((line) => line.trim() !== "");
    setOutputArray(lines);
  };

  const getFormattedOutput = () => {
    if (outputArray.length === 0) return "";

    switch (arrayFormat) {
      case "javascript":
        return `[\n  ${outputArray
          .map((item) => `"${item.replace(/"/g, '\\"')}"`)
          .join(",\n  ")}\n]`;
      case "json":
        return JSON.stringify(outputArray, null, 2);
      case "python":
        return `[\n  ${outputArray
          .map((item) => `"${item.replace(/"/g, '\\"')}"`)
          .join(",\n  ")}\n]`;
      case "csv":
        return outputArray.join(",");
      default:
        return `[\n  ${outputArray
          .map((item) => `"${item}"`)
          .join(",\n  ")}\n]`;
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(getFormattedOutput());
    alert("Array copied to clipboard!");
  };

  return (
    <div className={classes.container}>
      <header className={classes.header}>
        <h1>Text to Array Converter</h1>
        <p>Paste multiple lines on the left, get an array on the right</p>
      </header>

      <div className={classes.converterContainer}>
        <div className={classes.inputContainer}>
          <h2>Input Text</h2>
          <textarea
            className={classes.inputTextarea}
            value={inputText}
            onChange={handleInputChange}
            placeholder="Paste your text here, one item per line..."
          />
        </div>

        <div className={classes.outputContainer}>
          <div className={classes.outputHeader}>
            <h2>Output Array</h2>
            <div className={classes.formatSelector}>
              <label htmlFor="format">Format:</label>
              <select
                id="format"
                value={arrayFormat}
                onChange={(e) => setArrayFormat(e.target.value)}
                className={classes.select}
              >
                <option value="javascript">JavaScript</option>
                <option value="json">JSON</option>
                <option value="python">Python</option>
                <option value="csv">CSV</option>
              </select>
              <button className={classes.copyButton} onClick={copyToClipboard}>
                Copy
              </button>
            </div>
          </div>
          <pre className={classes.outputPre}>{getFormattedOutput()}</pre>
        </div>
      </div>

      <div className={classes.stats}>
        <p>Lines: {outputArray.length}</p>
      </div>
    </div>
  );
};

export default TextToArrayConverter;
